/**
 * https://yandex.ru/support/metrica/index.html
 *
 * Created by anatoly on 22/04/2024
 */

const YandexMetrikaLogger = function () {
    this.config = {
        lifetime: "180 days"
    };
};

YandexMetrikaLogger.prototype.trackEvent = function (name, params) {
    console.log("yandex metrika", name, params);

    connector.platform.callNative("YandexMetrika.logEvent", {
        name,
        order_price: params && params.value || 1
    });
};

YandexMetrikaLogger.prototype.trackPurchase = function (product, purchase, params) {
    connector.platform.callNative("YandexMetrika.logPurchase", {
        order_price: params.price,
        currency: params.currency
    });
};

YandexMetrikaLogger.prototype.trackAdRevenue = function (name, impressionCost) {
    connector.platform.callNative("YandexMetrika.logAdRevenue", {
        order_price: impressionCost * connector.EXCHANGE_RATES.RUB,
        currency: "RUB"
    });
};

YandexMetrikaLogger.isApplicable = function () {
    return connector.platform.oneOf(connector.CLEVERAPPS, connector.LABSYSTECH);
};